import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PorIconModel } from '@por/icon-lib/icons';
import { POR_SVG_ICONS } from './config';
import { SafeHtmlPipe } from './safe-html.pipe';
import { PorIconDirective } from './icon.directive';

@NgModule({
    imports: [CommonModule, SafeHtmlPipe, PorIconDirective],
    exports: [PorIconDirective, SafeHtmlPipe]
})
export class PorIconModule {
    static forRoot(porIcons: PorIconModel[]): ModuleWithProviders<PorIconModule> {
        return {
            ngModule: PorIconModule,
            providers: [
                {
                    provide: POR_SVG_ICONS,
                    useValue: porIcons
                }
            ]
        };
    }
}

// Alias for backward compatibility with apex library
export const ApxIconModule = PorIconModule;
